import cn from 'classnames';
import * as React from 'react';

import styles from './styles.module.scss';

export interface SpacerProps {
  className?: string;
  children?: string | React.ReactNode;
}

const Spacer: React.FC<SpacerProps> = ({ ...props }) => {
  return <div {...props} className={cn(props.className, styles.spacer)} />;
};

export default Spacer;
